import { yupResolver } from '@hookform/resolvers/yup'
import { TFunction } from 'i18next'
import isEmpty from 'lodash/isEmpty'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import ProfileFormValues from 'src/types/forms/profile/ProfileFormValues'
import { object, string } from 'yup'

const tForm = 'profile.details.form'

const getResolver = (t: TFunction) =>
  yupResolver(
    object().shape({
      firstName: string().required(t(`${tForm}.firstName.required`)),
      lastName: string().required(t(`${tForm}.lastName.required`)),
      email: string()
        .required(t(`${tForm}.email.required`))
        .email(t(`${tForm}.email.invalid`)),
      officeNumber: string().required(t(`${tForm}.officeNumber.required`)),
      mobileNumber: string().nullable().notRequired(),
      position: string().required(t(`${tForm}.position.required`)),
    }),
  )

const useProfileForm = (defaultValues: Partial<ProfileFormValues> = {}) => {
  const { t } = useTranslation()
  const resolver = getResolver(t)

  const form = useForm({
    resolver,
    defaultValues: {
      firstName: '',
      lastName: '',
      email: '',
      officeNumber: '',
      mobileNumber: '',
      position: '',
      ...defaultValues,
    },
    mode: 'onChange',
  })

  useEffect(() => {
    if (!isEmpty(defaultValues))
      form.reset({
        firstName: '',
        lastName: '',
        email: '',
        officeNumber: '',
        mobileNumber: '',
        position: '',
        ...defaultValues,
      })
  }, [defaultValues, form, form.reset])

  return form
}

export default useProfileForm
